import CONFIG from 'app.config';

export const TERMS_URL = `${CONFIG.SEARCH_APP_URL}/terms/sms`;
export const PRIVACY_URL = `${CONFIG.SEARCH_APP_URL}/privacy`;

/* Input options should have leading 0s to allow auto-fills to work correctly */

/* Date of Birth Options */
export const MONTH_OPTIONS = [
  { id: '01', name: 'January' },
  { id: '02', name: 'February' },
  { id: '03', name: 'March' },
  { id: '04', name: 'April' },
  { id: '05', name: 'May' },
  { id: '06', name: 'June' },
  { id: '07', name: 'July' },
  { id: '08', name: 'August' },
  { id: '09', name: 'September' },
  { id: '10', name: 'October' },
  { id: '11', name: 'November' },
  { id: '12', name: 'December' },
];

export const DAY_OPTIONS = Array.from(
  { length: 31 },
  (_, i) => {
    const dayName = (i + 1).toString();
    const dayId = dayName.padStart(2, '0');
    return { id: dayId, name: dayName };
  },
);

const currentYear = new Date().getFullYear();

export const YEAR_OPTIONS = Array.from(
  // Back to 1900
  { length: currentYear - 1900 + 1 },
  (_, i) => {
    const year = (currentYear - i).toString().padStart(4, '0');
    return { id: year, name: year };
  },
);

export const TIME_SLOT_FORMAT = 'dddd, MMM Do - h:mm a';
